module.exports = __webpack_public_path__ + "static/apple_splash_2048-42b8a22051014a5800a504bbd3f3b210.png";